import { Link } from "react-router-dom";
import PublicPage from "@/components/public/PublicPage";
import PublicLayout from "@/components/public/PublicLayout";
import { Seo } from "@/components/public/Seo";
import content from "./publicContent.json";

const byPath = Object.fromEntries(content.routes.map((r) => [r.path, r]));

const make = (path) => {
  const C = () => <PublicPage content={byPath[path]} />;
  return C;
};

export const VsmePage = make("/vsme");
export const PmiBanchePage = make("/pmi-banche");
export const EnvironmentalPage = make("/environmental");
export const SocialPage = make("/social");
export const GovernancePage = make("/governance");
export const CarbonCalculatorPage = make("/carbon-calculator");
export const CassettoEsgPage = make("/cassetto-esg");
export const EvaPage = make("/eva");
export const JobtimehrPage = make("/jobtimehr");
export const ConsulentiPage = make("/consulenti");
export const PmiPage = make("/pmi");
export const ChiSiamoPage = make("/chi-siamo");

export function NotFoundPage() {
  return (
    <PublicLayout>
      <Seo title="Pagina non trovata | ESG-PMI"
        description="La pagina richiesta non esiste o è stata spostata."
        path="/404" robots="noindex, follow" noCanonical />
      <main className="max-w-3xl mx-auto px-5 py-24 text-center" data-testid="not-found-page">
        <p className="text-xs font-bold tracking-widest uppercase" style={{ color: "#F28C28" }}>Errore 404</p>
        <h1 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900"
          style={{ fontFamily: "Manrope, sans-serif" }}>
          Questa pagina non esiste.
        </h1>
        <p className="mt-4 text-sm md:text-base text-slate-600 leading-relaxed">
          Il contenuto che cerchi potrebbe essere stato spostato. Ecco alcuni punti di partenza utili.
        </p>
        <nav aria-label="Pagine utili" className="mt-8 flex flex-wrap justify-center gap-3">
          {[
            ["Torna alla home", "/", true], ["Scopri il VSME", "/vsme"],
            ["Dialogo PMI-Banche", "/pmi-banche"], ["Richiedi una demo", "/richiedi-demo"],
          ].map(([label, to, primary]) => (
            <Link key={to} to={to}
              className={`inline-flex items-center gap-2 text-sm font-semibold px-5 py-3 rounded-md transition-colors ${primary ? "text-white" : "border-2"}`}
              style={primary ? { background: "#167A5A" } : { borderColor: "#123B66", color: "#123B66" }}
              data-testid={`nf-link-${to.slice(1) || "home"}`}>
              {label}
            </Link>
          ))}
        </nav>
      </main>
    </PublicLayout>
  );
}
